import React from 'react';

import StudentDetailScreen from './StudentDetailScreen';

export default (props: any) => <StudentDetailScreen {...props} mode="group" />;
